<template>
<div v-loading="loading">
  <vue-csv-import
    v-model="customers"
    :map-fields="mapFields"
  >
    <template
      slot="hasHeaders"
      slot-scope="{headers, toggle}"
    >
    <label>
      <input
        type="checkbox"
        id="hasHeaders"
        :value="headers"
        @change="toggle"
      >
      O arquivo tem cabeçalhos?
    </label>
    </template>

    <template slot="thead">
    <tr>
      <th>Campo</th>
      <th>Referência no arquivo</th>
    </tr>
    </template>

    <template
      slot="next"
      slot-scope="{load}"
    >
    <button
      @click.prevent="load"
      class="btn btn-fill btn-wd btn-success btn-block"
    >
      Carregar arquivo
    </button>
    </template>
  </vue-csv-import>
  <button
    v-if="customers.length"
    @click="handleImport()"
    class="btn btn-fill btn-wd btn-success btn-block"
  >
    Importar Clientes
  </button>
</div>
</template>

<script>
import _ from 'lodash'
import {mapGetters, mapActions} from 'vuex'
import {VueCsvImport} from 'vue-csv-import'
import {cpfIsValidRule} from 'src/services/ValidationRules.js'

export default {
  name: 'btn-customers-import',
  components: {
    VueCsvImport
  },
  data () {
    return {
      loading: false,
      mapFields: [
        'UC',
        'CPF',
        'Nome do Titular da conta',
        'Também conhecido como',
        'Nome da mãe',
        'Registro Geral (RG)',
        'Data de nascimento',
        'Telefone 1',
        'Telefone 2',
        'Logradouro',
        'Número',
        'Bairro',
        'Município',
        'CEP',
        'Complemento',
        'NIS'
      ],
      customers: [],
      importedCustomersDocs: [],
      customersTickets: [],
      queryCustomersDuplicated: {
        '$or': []
      },
      queryTicketsWinner: {
        '$or': []
      }
    }
  },
  computed: {
    ...mapGetters(['config', 'user']),
    eventId () {
      return this.$route.params.id
    }
  },
  methods: {
    ...mapActions('customers', {fetchOne: 'fetchOne', fetchCustomers: 'fetchAll', upsertCustomers: 'insertMany'}),
    ...mapActions('winners', {winnerByConfig: 'winnerByConfig', fetchWinners: 'fetchAll'}),
    ...mapActions('tickets', {
      fetchTickets: 'fetchAll',
      createTicket: 'createTicket',
      getTicketBarcode: 'getTicketBarcode',
      checkWinnerOld: 'checkWinnerOld',
      isWinnerTrgNewer: 'isWinnerTrgNewer',
      upsertTickets: 'insertMany'
    }),
    async handleImport () {
      this.loading = true
      this.createImportedDocuments()
      this.fetchCustomers(/* {where: this.queryCustomersDuplicated} */)
        .then(results => {
          this.importedCustomersDocs = this.importedCustomersDocs.map(doc => {
            const oldDoc = results.find(item => item.uc === doc.uc)
            if (oldDoc) {
              return Object.assign(oldDoc, doc, {_id: oldDoc._id})
            }
            return doc
          })
          this.importedCustomersDocs = this.importedCustomersDocs.filter(doc => {
            const oldCpfDoc = results.find(item => item.cpf.replace(/[^\d]+/g, '') === doc.cpf)
            if (oldCpfDoc) {
              return false
            }
            return true
          })

          Promise.all([
            this.upsertCustomers(this.importedCustomersDocs),
            this.execCreateTickets()
          ])
            .then(results => {
              window.location.reload(true)
            })
        })
        .finally(() => {
          this.loading = true
        })
    },
    async execCreateTickets () {
      return Promise.all([
        this.fetchWinners(this.queryTicketsWinner),
        this.fetchTickets({
          where: {
            '$or': this.importedCustomersDocs.map(item => Object.assign({}, {
              customerId: item._id
            }))
          }
        })
      ])
        .then(results => {
          this.createTicketCustomers({winners: results[0], oldTickets: results[1]})
          return this.upsertTickets(this.customersTickets)
        })
    },
    createImportedDocuments () {
      for (let customer of this.customers) {
        if (!cpfIsValidRule.validate(customer.CPF)) {
          continue
        }
        this.createQueryDuplications(customer)
        this.importedCustomersDocs.push(
          {
            _id: this.createHashId(),
            'uc': customer.UC,
            'cpf': customer.CPF.replace(/[^\d]+/g, ''),
            'nationalId': customer.RG,
            'birthdate': customer['Data de nascimento'],
            'holder': customer['Nome do Titular da conta'],
            'aka': customer['Também conhecido como'],
            'motherName': customer['Nome da mãe'],
            'phone1': customer['Telefone 1'],
            'phone2': customer['Telefone 2'],
            'address': {
              'street': customer['Logradouro'],
              'number': customer['Número'],
              'neighborhood': customer['Bairro'],
              'city': customer['Município'],
              'zip': customer['CEP'],
              'complement': customer['Complemento']
            },
            'observartion': '',
            'nis': customer['NIS'],
            'contemplated': null,
            'phones': [
              customer['Telefone 1'],
              customer['Telefone 2']
            ],
            'collection': 'customers',
            'userId': this.user._id,
            'createdAt': new Date()
          }
        )
      }
    },
    createTicketCustomers ({winners, oldTickets}) {
      for (let customer of this.importedCustomersDocs) {
        const eligible = this.verifyElegible({winners, oldTickets, customer})
        // const oldTicket = oldTickets.find(item => item.customerId === customer._id)
        let doc = {
          collection: 'tickets',
          winner: false,
          eligible,
          reasonNotEligible: !eligible ? 'Já foi contemplado anteriormente.' : '',
          customerId: customer._id,
          eventId: this.eventId,
          barcode: `${customer.uc}${_.random(10000000, 99999999)}`,
          createdAt: new Date()
        }
        // if (oldTicket) {
        //   doc = Object.assign({}, oldTicket, doc, {_id: oldTicket._id})
        // }
        this.customersTickets.push(doc)
      }
    },
    verifyElegible ({winners, oldTickets, customer}) {
      const oldEventsWinner = winners.find(winner => {
        if (this.config.validationCustomer.uc && this.config.validationCustomer.cpf) {
          return winner.uc === customer.uc && winner.cpf === customer.cpf.replace(/\D/g, '')
        }

        if ((this.config.validationCustomer.uc) && !this.config.validationCustomer.cpf) {
          return winner.uc === customer.uc
        }

        if ((this.config.validationCustomer.cpf) && !this.config.validationCustomer.uc) {
          return winner.cpf === customer.cpf.replace(/\D/g, '')
        }

        if (this.config.validationCustomer.ucOrCpf) {
          return winner.uc === customer.uc || winner.cpf === customer.cpf.replace(/\D/g, '')
        }
      })

      if (oldEventsWinner) {
        return false
      }

      const ticketWinner = oldTickets.find(ticket => ticket.customerId === customer._id && ticket.winner)
      if (ticketWinner) {
        return false
      }

      return true
    },
    createQueryDuplications (customer) {
      let query = []
      let queryWinner = []
      if (this.config.validationCustomer.uc && this.config.validationCustomer.cpf) {
        query = {'$and': []}
        query['$and'].push({uc: customer.UC})
        query['$and'].push({cpf: customer.CPF})

        queryWinner = {'$and': []}
        queryWinner['$and'].push({uc: customer.UC})
        queryWinner['$and'].push({cpf: customer.CPF.replace(/\D/g, '')})
      }

      if ((this.config.validationCustomer.uc) && !this.config.validationCustomer.cpf) {
        query = {'$and': []}
        query['$and'].push({uc: customer.UC})

        queryWinner = {'$and': []}
        queryWinner['$and'].push({uc: customer.UC})
      }

      if ((this.config.validationCustomer.cpf) && !this.config.validationCustomer.uc) {
        query = {'$and': []}
        query['$and'].push({cpf: customer.CPF})
        queryWinner = {'$and': []}
        queryWinner['$and'].push({cpf: customer.CPF.replace(/\D/g, '')})
      }

      if (this.config.validationCustomer.ucOrCpf) {
        query = {'$or': []}
        query['$or'].push({uc: customer.UC})
        query['$or'].push({cpf: customer.CPF})

        queryWinner = {'$or': []}
        queryWinner['$or'].push({uc: customer.UC})
        queryWinner['$or'].push({cpf: customer.CPF.replace(/\D/g, '')})
      }

      this.queryCustomersDuplicated['$or'].push(query)
      this.queryTicketsWinner['$or'].push(queryWinner)
    },
    createHashId () {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < 23; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result + '-imported' // -imported = 9 caracteres
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnCustomersImport.vue